import { parseDate } from './utils'

export default class ProcessProviderHistory {
	static fromJSON(json) {
		return new ProcessProviderHistory(json.id)
			.withStartDate(json.startDate)
			.withEndDate(json.endDate)
			.withEstablishment(json.establishment)
	}

	constructor(id) {
		this.id = id
		this.key = `process_provider_history_${id || ''}`
	}

	withStartDate(dateStr) {
		this.startDate = dateStr ? parseDate(dateStr) : null
		return this
	}

	withEndDate(dateStr) {
		this.endDate = dateStr ? parseDate(dateStr) : null
		return this
	}

	withEstablishment(json) {
		this.establishment = json
			? {
					id: json.id,
					name: json.name,
			  }
			: null
		return this
	}
}
